import { lazy } from 'react';

// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import XeokitPage from '../pages/xeokit';

// render- Home
const Home = Loadable(lazy(() => import('pages/home')));
const CesiumMap = Loadable(lazy(() => import('pages/cesiumMap')));

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));

// render - datatable
const EnhancedDatatablePage = Loadable(lazy(() => import('pages/datatable/EnhancedDatatable')));
const EnhancedDatatableV2Page = Loadable(lazy(() => import('pages/datatable/EnhancedDatatableV2Page')));

// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

//render page baru
const Projects = Loadable(lazy(() => import('pages/dashboard/projects')));
const Viewdata = Loadable(lazy(() => import('pages/dashboard/viewdata')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: <DashboardLayout />,
  children: [
    {
      index: 'true',
      element: <Home />
    },
    {
      path: 'dashboard', // route baru
      element: <Projects />
    },
    {
      path: '3d-map', // route baru
      element: <CesiumMap />
    },
    {
      path: 'xeokit', // route baru
      element: <XeokitPage />
    },
    {
      path: 'maintenance-reminder', // route baru
      element: <Viewdata />
    },
    {
      path: 'dashboard',
      children: [
        {
          path: 'default',
          element: <DashboardDefault />
        },
        {
          path: 'projects',
          element: <Projects />
        },
        {
          path: 'viewdata',
          element: <Viewdata />
        }
      ]
    },
    {
      path: 'datatable',
      children: [
        {
          path: 'enhanced',
          element: <EnhancedDatatablePage />
        },
        {
          path: 'enhanced-v2',
          element: <EnhancedDatatableV2Page />
        }
      ]
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    }
  ]
};

export default MainRoutes;
